import WalletModal from "@components/modal/WalletModal.component";
import { CROWN } from "@constants/images";
import { useContext, useEffect, useState } from "react";
import { RiWallet3Line } from "react-icons/ri";
import { SCOREMethodGetCall } from "@services/icon";
import { walletContext } from "@src/core/context/walletContext";
import { ENUM_SCORES } from "@enum/contracts.enum";
import { SALES_STATE } from "@enum/salesStatus.enum";

import GangstaBetPickerModal from "@components/modal/GangstabetPickerModal.component";
import CongratulationsModal from "@components/modal/CongratulationsModal.component";
import LoadingModal from "@components/modal/LoadingModal.component";

interface IWalletConnection {
  connectedAccount: string;
  setModalGBPickerModalOpen: any;
  isMintingSuccess: any;
}

const WalletConnectedState = ({
  connectedAccount,
  setModalGBPickerModalOpen,
  isMintingSuccess,
}: IWalletConnection) => {
  const [cap, setCap] = useState < number > (0);
  const [reservationCost, setReservationCost] = useState < number > (0);
  const [reservationCount, setReservationCount] = useState < number > (0);
  const [availableCrown, setAvailableCrown] = useState < number > (0);

  const fetchChainData = async () => {
    const getCapPromise = SCOREMethodGetCall(
      "getCap",
      ENUM_SCORES.ILLUSTRATION_MINT
    );

    const getReservationCostPromise = SCOREMethodGetCall(
      "getReservationCost",
      ENUM_SCORES.ILLUSTRATION_MINT
    );

    const getReservationCountPromise = SCOREMethodGetCall(
      "getReservationCount",
      ENUM_SCORES.ILLUSTRATION_MINT
    );

    const getbalanceOfPromise = SCOREMethodGetCall(
      "balanceOf",
      ENUM_SCORES.CROWN,
      { _owner: connectedAccount }
    );

    const [
      getCap,
      getReservationCost,
      getReservationCount,
      getBalanceOf,
    ] = await Promise.allSettled([
      getCapPromise,
      getReservationCostPromise,
      getReservationCountPromise,
      getbalanceOfPromise,
    ]);

    if (getCap.status === "fulfilled") {
      console.log("cap", getCap.value);
      setCap(parseInt(getCap.value, 16));
    }

    if (getReservationCost.status === "fulfilled") {
      setReservationCost(getReservationCost.value / 1e18);
    }

    if (getReservationCount.status === "fulfilled") {
      setReservationCount(parseInt(getReservationCount.value, 16));
    }

    if (getBalanceOf.status === "fulfilled") {
      setAvailableCrown(getBalanceOf.value / 1e18);
    }
  };

  useEffect(() => {
    fetchChainData();
  }, [isMintingSuccess]);

  return (
    <div className="wallet-connected-info">
      <div className="available-info">
        <h4 className="available-number">Total Slots: {cap}</h4>
        <p className="wallet-address">
          <RiWallet3Line />
          {connectedAccount.slice(0, 4)}...{connectedAccount.slice(-4)}
        </p>
      </div>
      <h4 className="mint-count">
        Slots available for reserve: {cap - reservationCount}
      </h4>
      <p className="wallet-desc">
        You will need to select the Gangstabet NFT and we will create the
        illustration within a few week(s).
      </p>
      <div className="wallet-info">
        <div className="wallet-crown">
          <div className="wallet-price-name">
            <p className="wallet-label-wallet">Wallet :</p>
            <p className="wallet-label-price">Price :</p>
          </div>
          <div className="wallet-price-value">
            <div className="wallet-crown-log">
              <div className="wallet-value">
                <img src={CROWN} alt="crown" />
                <p>{availableCrown.toFixed(2)}</p>
              </div>
              <div className="price-value">
                <img src={CROWN} alt="crown" />
                <p>
                  {Number(reservationCost)
                    .toFixed(0)
                    .toLocaleString()}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="reserve-btn">
          {Number(availableCrown) > Number(reservationCost) && (
            <button
              className="btn"
              onClick={() => {
                setModalGBPickerModalOpen(true);
              }}
            >
              Reserve
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

const WalletDisconnectedState = ({ setModalOpen, getSaleState }: any) => {
  return (
    <>
      {getSaleState === SALES_STATE.SALE_STARTED ? (
        <button
          className="btn connect-wallet-btn"
          onClick={() => setModalOpen(true)}
        >
          Connect your Wallet
        </button>
      ) : (
        <>
          {getSaleState === SALES_STATE.SALE_NOT_STARTED && (
            <div className="wallet-connected-info">
              <p className="saleStatus">Reservation will start very soon!</p>
            </div>
          )}
          {getSaleState === SALES_STATE.SALE_OVER && (
            <div className="wallet-connected-info">
              <p className="saleStatus">Reservation is closed.
              </p>
            </div>
          )}
          {getSaleState === SALES_STATE.SALE_PAUSED && (
            <div className="wallet-connected-info">
              <p className="saleStatus">Reservation has been paused.<br /><br /> We will resume it shortly.
              </p>
            </div>
          )}
          {getSaleState === SALES_STATE.SOLD_OUT && (
            <div className="wallet-connected-info">
              <p className="saleStatus">All of the available slots have been reserved and illustrations are being created. <br /><br />Be on the lookout for the next phase of reservations !
              </p>
            </div>
          )}
        </>
      )}
    </>
  );
};

const IllustrationMintCase = ({ setReservationState }: any) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [getSaleState, setSalesState] = useState < SALES_STATE > ();
  const [modalGBPickerModalOpen, setModalGBPickerModalOpen] = useState(false);
  const walletContextValue = useContext(walletContext);
  const [isMintingSuccess, setMintingSuccess] = useState < boolean | null > (null);
  const [isMintingLoading, setMintingLoading] = useState < boolean | null > (null);
  const fetchInfo = async () => {
    const salesStatusPromise = SCOREMethodGetCall(
      "getSaleStatus",
      ENUM_SCORES.ILLUSTRATION_MINT
    );
    const [salesStatus] = await Promise.allSettled([salesStatusPromise]);

    if (salesStatus.status === "fulfilled") {
      console.log(salesStatus.value);
      setSalesState(salesStatus.value);
    }
  };
  useEffect(() => {
    fetchInfo();
  }, [modalGBPickerModalOpen, isMintingSuccess, modalOpen]);
  return (
    <div>
      {walletContextValue.address &&
        getSaleState === SALES_STATE.SALE_STARTED ? (
        <WalletConnectedState
          connectedAccount={walletContextValue.address}
          setModalGBPickerModalOpen={setModalGBPickerModalOpen}
          isMintingSuccess={isMintingSuccess}
        />
      ) : (
        <WalletDisconnectedState
          getSaleState={getSaleState}
          setModalOpen={setModalOpen}
        />
      )}

      {/* TODO Refractor modals to live without state variables */}
      {modalOpen && <WalletModal setPopupOpen={setModalOpen} />}

      {modalGBPickerModalOpen && (
        <GangstaBetPickerModal
          setPopupOpen={setModalGBPickerModalOpen}
          setMintingSuccess={setMintingSuccess}
          setMintingLoading={setMintingLoading}
          connectedAccount={walletContextValue.address}
          isMintingLoading={isMintingLoading}
          isMintingSuccess={isMintingSuccess}
        />
      )}

      {isMintingSuccess && (
        <CongratulationsModal
          setReservationState={setReservationState}
          setPopupOpen={setMintingSuccess}
          setModalGBPickerModalOpen={setModalGBPickerModalOpen}
        />
      )}

      {isMintingLoading && <LoadingModal setPopupOpen={setMintingSuccess} />}
    </div>
  );
};

export default IllustrationMintCase;
